import React from 'react';
import { Redirect } from 'react-router-dom';
import { FuseUtils } from '@fuse/index';
import { ExampleConfig } from 'main/content/example/ExampleConfig';
import { LoginConfig } from '../main/content/login/LoginConfig';
import { CompanyConfig } from '../main/content/company/CompanyConfig';
import { SettlementConfig } from '../main/content/settlement/SettlementConfig';
import { BrokerConfig } from '../main/content/brokersettlement/BrokerSettlementConfig';
import {InvestorsConfig} from "../main/content/investors/InvestorsConfig";
import {InboundConfig} from "../main/content/inbound/inboundConfig";
import {OutboundConfig} from "../main/content/outbound/outboundConfig";
import {BankConfig} from "../main/content/bank/bankConfig";
import {ReportingConfig} from "../main/content/reporting/reportingConfig";
import {ReconciliationConfig} from "../main/content/reconciliation/reconciliationConfig";
import {KYCConfig} from "../main/content/kyc/kycConfig";
import {OpenordersConfig} from "../main/content/openorders/openordersConfig";


const routeConfigs = [
  ExampleConfig,
  LoginConfig,
  CompanyConfig,
  BrokerConfig,
  SettlementConfig,
  InvestorsConfig,
  InboundConfig,
  OutboundConfig,
  BankConfig,
  ReportingConfig,
  ReconciliationConfig,
  KYCConfig,
  OpenordersConfig
];

export const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    component: () => <Redirect to="/login" />
  }
];
